module.exports = __webpack_public_path__ + "img/cur3.5948a0b1.png";